import { render, staticRenderFns } from "./image-modal.vue?vue&type=template&id=02760682&scoped=true"
import script from "./image-modal.vue?vue&type=script&lang=js"
export * from "./image-modal.vue?vue&type=script&lang=js"
import style0 from "./image-modal.vue?vue&type=style&index=0&id=02760682&prod&lang=scss&scoped=true&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "02760682",
  null
  
)

export default component.exports